import { mapData } from "@/utilities/DataMapping";

export interface IQuestionReportItem {
    question: string;
    correctCount: number;
    incorrectCount: number;
}

export class QuestionReportItem implements IQuestionReportItem {

    constructor(data?: IQuestionReportItem) {
        if (data) this.update(data);
    }

    update(data: IQuestionReportItem): QuestionReportItem {
        mapData(data, { root: () => this });
        return this;
    }

    question: string = "";
    correctCount: number = 0;
    incorrectCount: number = 0;

    get correctPercent(): number {
        return (this.correctCount / (this.correctCount + this.incorrectCount)) * 100;
    }

    get incorrectPercent(): number {
        return (this.incorrectCount / (this.correctCount + this.incorrectCount)) * 100;
    }

    get correctLabel(): string {
        return `${this.correctCount} (${Math.round(this.correctPercent)}%)`;
    }

    get incorrectLabel(): string {
        return `${this.incorrectCount} (${Math.round(this.incorrectPercent)}%)`;
    }
}